// 所有代码表的映射关系
const codeTables = {
  // 点检类型
  inspectionType: [
    { label: '日点检', value: '1' },
    { label: '月点检', value: '2' },
    { label: '季点检', value: '3' },
    { label: '年点检', value: '4' },
    { label: '一级保养', value: '5' },
    { label: '二级保养', value: '6' },
  ],
  moduleInspectionType: [
    { label: '一级保养', value: '5' },
    { label: '二级保养', value: '6' },
    { label: '三级保养', value: '7' },
    { label: '模具维修', value: '8' },
  ],
  approvalStatusList: [
    { text: "审核中", value: "0" },
    { text: "审核完成", value: "1" },
    { text: "驳回", value: "2" },
  ],
  // 可以继续添加其他代码表
  // deviceStatus: new Map([...]),
}

export default {
  data() {
    return {
      ...codeTables
    }
  },
  methods: {
    /**
     * 获取代码表对应文本
     * @param {String} tableName 代码表名称
     * @param {String} codeValue 代码值
     * @param {String} defaultValue 默认显示值
     * @returns {String} 对应的文本标签
     */
    getCodeLabelByValue(tableName, codeValue, defaultValue = '--') {
      // return map;
      const codeTable = []
      tableName.forEach(name=>{
        codeTable.push(...codeTables[name])
      })

      if (!codeTable) {
        console.warn(`[CodeTableMixin] 未找到代码表: ${tableName}`)
        return defaultValue
      }
      const codeMap = new Map();
      codeTable.forEach(item => {
        codeMap.set(item.value, item.label);
      });
      return codeMap.get(codeValue.toString()) || defaultValue
    },

    /**
     * 动态注册代码表
     * @param {String} tableName 代码表名称
     * @param {Array} options 代码表数组 [{label,value}]
     */
    registerCodeTable(tableName, options) {
      codeTables[tableName] = new Map(options.map(item => [item.value, item.label]))
    },
    filterApprovalStatus(value, row) {
      return row.approval_status === value;
    }
  }
}


// WEBPACK FOOTER //
// ./src/mixins/codeTableMixin.js